<!-- <app-header></app-header> -->
<div class="container-fluid content_body">
  <app-request-clinic [currentRoute]="this.currentRoute"></app-request-clinic>
</div>